// src/store/ocrSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null, // stores the OCR/attendance sheet JSON
};

const ocrSlice = createSlice({
	name: 'ocr',
	initialState,
	reducers: {
		// store OCR data
		setOcrData: (state, action) => {
			state.data = action.payload;
		},
		// clear OCR data
		clearOcrData: (state) => {
			state.data = null;
		},
	},
});

export const { setOcrData, clearOcrData } = ocrSlice.actions;
export default ocrSlice;
